import { ACTIONS_INBOUND_EMAIL_LOG } from '_constants/inboundEmailLog.constants';
import alertActions from './alert.actions';
import inboundEmailLogService from '../_services/inboundEmailLog.service';

export const receiveInboundEmailLogs = (inboundEmailLogs) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < inboundEmailLogs.length; i++) {
    byIdObjectToDispatch[inboundEmailLogs[i].inboundEmailLogID] = inboundEmailLogs[i];
  }

  return {
    type: ACTIONS_INBOUND_EMAIL_LOG.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteActivity = (inboundEmailLogID) => ({
  type: ACTIONS_INBOUND_EMAIL_LOG.DELETE,
  byId: { [inboundEmailLogID]: null }
});

const getInboundEmailLogs = (numberToRetrieve) => async (dispatch) => {
  try {
    const resp = await inboundEmailLogService.getMostRecent(numberToRetrieve);
    if (resp?.[0]?.inboundEmailLogID) {
      dispatch(receiveInboundEmailLogs(resp));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving email logs.'));
  }
  return null;
};

export default {
  getInboundEmailLogs,
};
